import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import useDocumentTitle from '../../../components/useDocumentTitle';
import { client } from "../../../config/ipfsConfig";
import { getCollectionListbyWalletAddress } from '../../../hooks/Collectionhook';
import { getUserByAddress } from '../../../hooks/User';
import { CreateLazyPost } from "../../../hooks/LazyMinting"
import { ethers, toBigInt } from 'ethers';
import { MdDelete, MdKeyboardArrowUp, MdOutlineKeyboardArrowDown } from 'react-icons/md';
import Papa from 'papaparse';
import { FaCirclePlus } from "react-icons/fa6";
import { SIGNING_DOMAIN_NAME, SIGNING_DOMAIN_VERSION, contractAddress, chainId } from '../../../config/BackendUrl';
import { ToastContainer, toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { collectionABI } from '../../../config/ABIs/CollectionABI';
import { ContractABI } from '../../../config/ABIs/ContractABI';
import useFullPageLoader from '../../../hooks/useFullPageLoader';
import { createNFTDraft } from '../../../hooks/DraftHook';
import "./Upload.css";

const Upload = () => {
  useDocumentTitle('Mint');
  const [fileUrl, setFileUrl] = useState(null);
  const [type, setType] = useState(null);
  const [fileName, setFileName] = useState(null);
  const [fileSize, setFileSize] = useState(null);

  const [formInput, updateFormInput] = useState({});
  const [collection, setCollection] = useState([]);
  const walletAddress = localStorage.getItem("WalletAddress");
  const [attributes, setAttributes] = useState([]);
  const [newAttribute, setNewAttribute] = useState({ trait_type: '', value: '' });
  const [propertiesFile, setPropertiesFile] = useState(null);
  const [csvFileName, setCsvFileName] = useState(null);
  const [userData, setUserData] = useState({});
  const [show, setShow] = useState(false);
  const [collectionshow, setCollectionshow] = useState(false);
  const [isSelected, setIsSelected] = useState(false);
  const [priceError, setPriceError] = useState('');
  const [errorMessages, setErrorMessages] = useState({});
  const [assetError, setAssetError] = useState('');

  const [selectObj, setSelectObj] = useState({ logo: "img/logos/dtoc.png", "name": "DtoC", symbol: "D2C", contractAddress: contractAddress })
  const route = useNavigate();
  const PROVIDER = useSelector((state) => state.valueFromHeader);


  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (file) {
      const url = URL.createObjectURL(file);  // Create file URL for preview
      const type = file.type;  // Get file MIME type
      const size = file.size;  // Get file size
      setFileName(file.name);

      // setFileUrl(url);  // Set file URL
      setType(type);  // Set MIME type
      setFileSize(size);  // Set file size

      // Validate the file
      const error = validateAsset(url, type, size);
      console.log("error", error);
      if (error) {
        setAssetError(error);  // Show error message if validation fails
        console.log("1");
      } else {
        console.log("0");
        setAssetError("");  // Clear error if validation passes
        try {
          const added = await client.add(file);
          const url = `https://ipfs.infura.io/ipfs/${added.path}`;
          setFileUrl(url);
        } catch (error) {
          toast.error("Error uploading file: ", error);
        }
      }
    }
  };
  // Asset validation function
  const validateAsset = (fileUrl, fileType, fileSize) => {
    let error = null;

    // Check if file is uploaded
    if (!fileUrl) {
      error = "Please upload an asset (image or video).";
    } else {
      // Check if file is an image or video
      const fileMimeType = fileType && fileType.split('/')[0];

      // Validate image size (max 1 MB)
      if (fileMimeType === "image") {
        if (fileSize > 50 * 1024 * 1024) {  // 1 MB in bytes
          error = "Image size exceeds 1 MB.";
        }
      }

      // Validate video size (max 10 MB)
      if (fileMimeType === "video") {
        if (fileSize > 50 * 1024 * 1024) {  // 10 MB in bytes
          error = "Video size exceeds 10 MB.";
        }
      }

      // Validate file type (only image and video are allowed)
      if (fileMimeType !== "image" && fileMimeType !== "video") {
        error = "Only images (PNG, GIF, WEBP) and videos (MP4) are allowed.";
      }
    }

    return error;
  };


  const closeButton = () => {
    setFileUrl(null)
    setFileName(null)
  }
  async function handleChange(e) {
    updateFormInput({
      ...formInput,
      [e.target.name]: e.target.value,
    })
  }

  async function handleChangeOfPrice(e) {
    const valueofPrice = e.target.value;
    if (selectObj.name === "DtoC") {
      if (valueofPrice <= 0.019) {
        setPriceError("Price of NFTs must be greater than or equal 0.02 or 0")
      }
      else {
        setPriceError("")
        updateFormInput({
          ...formInput,
          [e.target.name]: e.target.value,
        })
      }

    }
    else {
      updateFormInput({
        ...formInput,
        [e.target.name]: e.target.value,
      })
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    if (walletAddress)
      getUserByAddress(walletAddress).then((data) => {
        setUserData(data.user);
      })
    getCollectionListbyWalletAddress(walletAddress).then((data) => {
      if (data.status === 201) {
        const Collect = data.data
        const newArray = Collect.map((item, i) => {
          return { ...item, isActive: false }; // Update object at specific index
        });
        setCollection(newArray)
      }
    })
  }, [walletAddress])


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewAttribute({ ...newAttribute, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (newAttribute.trait_type !== "" && newAttribute.value !== "") {
      setAttributes([...attributes, newAttribute]);
      setNewAttribute({ trait_type: '', value: '' });
    }
  };

  const onJsonChange = (event) => {
    const uploadedFile = event.target.files[0];
    setCsvFileName(event.target.files[0].name)
    if (uploadedFile) {
      const reader = new FileReader();
      reader.onload = (event) => {
        const csvData = event.target.result;
        // Parse the CSV data using papaparse
        const parsedData = Papa.parse(csvData, { header: true }); // Adjust options as needed
        setPropertiesFile(parsedData.data);
      };
      reader.readAsText(uploadedFile);
    } else {
      console.error("Please select a CSV file");
    }
  };

  const handleDelete = (index) => {
    const newAttributes = attributes.filter((_, i) => i !== index);
    setAttributes(newAttributes);
  };

  function updateStateByIndex(index, newState, obj, stateValue) {
    setIsSelected(stateValue)
    setCollectionshow(false)
    setSelectObj(obj)
    getCollectionListbyWalletAddress(walletAddress).then((data) => {
      const Collect = data.data
      const GetCollection = Collect.map((item, i) => {
        return { ...item, isActive: false }; // Update object at specific index
      });
      if (index) {
        const newArray = GetCollection.filter((data, i) => i !== index).map((item, i) => {
          if (i === index) {
            return { ...item, isActive: newState }; // Update object at specific index
          }
          if (newState === true) {
            if (i !== index) {
              return { ...item, isActive: false };
            }
          }
          else {
            if (i !== index) {
              return { ...item, isActive: true };
            }
          }
          return item; // Keep other elements unchanged
        });
        setCollection(newArray); // Assuming 'setMyArray' is a state setter function
      }
    })
  }

  const CreateMint = async () => {
    // showLoader();
    if (formInput.price?.trim() === '') {
      toast.error('Price is required!');
      return; // Stop execution if validation fails
    }
    if (!walletAddress) {
      toast.error("Please Connect Wallet First")
    }
    else {
      if (isSelected) {
        await OtherCollection();
      }
      else {
        await DtocCollection();
      }
    }
  };

  const OtherCollection = async () => {
    try {
      let url;
      let dataObject = {
        title: formInput.title,
        type: type,
        desc: formInput.desc,
        category: formInput.category,
        image: fileUrl,
        creator: userData?.name,
      };

      if (attributes.length !== 0) {
        dataObject.attributes = attributes;
      }

      if (propertiesFile !== null) {
        dataObject.properties = propertiesFile;
      }

      const data = JSON.stringify(dataObject);


      const added = await client.add(data);
      url = `https://dtoc.infura-ipfs.io/ipfs/${added.path}`;
      const wallet = await PROVIDER.getSigner();

      const contracts = new ethers.Contract(
        selectObj.contractAddress,
        collectionABI,
        wallet
      );
      const royaltyFraction = formInput.Royalty * 100;
      const test = await contracts.safeMint(
        walletAddress,
        url,
        royaltyFraction
      );

      const receipt = await test.wait();
      if (receipt) {
        toast.success("Transaction successful. Created NFT successfully !!!")
        setTimeout(() => {
          route('/marketplace');
          // hideLoader();
        }, 2000);
      }
    } catch (error) {
      console.error("Error calling function:", error);
    }
  };

  const DtocCollection = async () => {
    try {
      let url;
      let dataObject = {
        title: formInput.title,
        type: type,
        desc: formInput.desc,
        category: formInput.category,
        image: fileUrl,
        creator: userData?.name,
      };

      if (attributes.length !== 0) {
        dataObject.attributes = attributes;
      }

      if (propertiesFile !== null) {
        dataObject.properties = propertiesFile;
      }

      const data = JSON.stringify(dataObject);


      const added = await client.add(data);
      url = `https://dtoc.infura-ipfs.io/ipfs/${added.path}`;
      const wallet = await PROVIDER.getSigner();
      const contracts = new ethers.Contract(
        contractAddress,
        ContractABI,
        wallet
      );
      const price = ethers.parseEther(formInput.price);
      const test = await contracts.createToken(
        url,
        price
      );

      const receipt = await test.wait();
      if (receipt) {
        toast.success("Transaction successful. Created NFT successfully !!!")
        setTimeout(() => {
          route('/marketplace');
        }, 2000);
      }
    } catch (error) {
      console.error("Error calling function:", error);
    }
  };

  const LazyPost = async () => {
    // showLoader();
    console.log("Foirm", formInput);
    if (!walletAddress) {
      toast.error("Please Connect Wallet First !!!")
    }
    else if (!userData._id) {
      toast.error("Please Create Profile First !!!")
    }
    else {
      const ContractAddress = selectObj.contractAddress; // Put the address here from remix
      const signer = await PROVIDER.getSigner();

      const domain = {
        name: SIGNING_DOMAIN_NAME,
        version: SIGNING_DOMAIN_VERSION,
        verifyingContract: ContractAddress,
        chainId,
      };
      let url;
      let signature;
      let dataObject = {
        title: formInput.title,
        type: type,
        desc: formInput.desc,
        category: formInput.category,
        image: fileUrl,
        creator: userData?.name,
      };

      if (attributes.length !== 0) {
        dataObject.attributes = attributes;
      }

      if (propertiesFile !== null) {
        dataObject.properties = propertiesFile;
      }

      const data = JSON.stringify(dataObject);



      const royaltyFraction = formInput.Royalty * 100;
      const added = await client.add(data);
      url = `https://dtoc.infura-ipfs.io/ipfs/${added.path}`;

      async function createVoucher(price, uri, royaltyFraction) {
        const voucher = { price, uri, royaltyFraction };
        const types = {
          LazyNFTVoucher: [
            { name: "price", type: "uint256" },
            { name: "uri", type: "string" },
            { name: "royaltyFraction", type: "uint96" },
          ],
        };

        signature = await signer.signTypedData(domain, types, voucher);
        return {
          ...voucher,
          signature,
        };
      }

      const priceInWei = ethers.parseEther(formInput.price);
      await createVoucher(priceInWei, url, toBigInt(royaltyFraction))

      const signatureArr = [signature]
      const body = {
        image: fileUrl,
        userId: userData._id,
        title: formInput.title,
        desc: formInput.desc,
        walletAddress: walletAddress,
        royaltyFraction: formInput.Royalty * 100,
        price: formInput.price,
        tokenURI: url,
        contractAddress: selectObj.contractAddress,
        category: formInput.category,
        signature: signatureArr,
        type: type
      }
      console.log("body", body);
      CreateLazyPost(body).then((res) => {
        if (res.status === 201) {
          toast.success("Created NFT successfully !!!")
          setTimeout(() => {
            route('/marketplace');
            // hideLoader();
          }, 2000);
        }
        else if (res.status === 400) {
          toast.error(res.message);
        }
      })
    }
  };

  const DraftPost = async () => {
    // showLoader();

    if (!userData._id) {
      toast.error("Please Create Profile First !!!")
    }
    else {
      let url;
      let dataObject = {
        title: formInput.title,
        type: type,
        desc: formInput.desc,
        category: formInput.category,
        image: fileUrl,
        creator: userData?.name,
      };

      if (attributes.length !== 0) {
        dataObject.attributes = attributes;
      }

      if (propertiesFile !== null) {
        dataObject.properties = propertiesFile;
      }

      const data = JSON.stringify(dataObject);



      const added = await client.add(data);
      url = `https://dtoc.infura-ipfs.io/ipfs/${added.path}`;

      const body = {
        contractAddress: selectObj.contractAddress,
        uri: url,
        walletAddress: walletAddress,
        status: false
      }

      createNFTDraft(body).then((res) => {
        if (res.status === 201) {
          toast.success("Created NFT successfully !!!")
          setTimeout(() => {
            route('/profile', { state: "draft" });
            // hideLoader();
          }, 2000);

        }
        else if (res.status === 400) {
          toast.error(res.message);
        }
      })
    }
  };

  const ValidationhandleSubmit = (func) => {
    let valid = true;
    let errors = {};

    // 1. Asset Validation (using the validateAsset function)
    const assetError = validateAsset(fileUrl, type, fileSize);
    if (assetError) {
      valid = false;
      errors.asset = assetError;
    }

    // 2. Title Validation
    if (!formInput.title || formInput.title.trim() === "") {
      valid = false;
      errors.title = "Title is required.";
    }

    // 3. Price Validation
    if (!formInput.price || formInput.price <= 0) {
      valid = false;
      console.log("formInput.price > 0", formInput.price > 0.0000, typeof (formInput.price), formInput.price);
      errors.price = "Price must be a positive number.";
    }

    // 4. Category Validation
    if (!formInput.category || formInput.category === "Select a category") {
      valid = false;
      errors.category = "Please select a category.";
    }

    // 5. Royalty Validation (if not "DtoC")

    if (formInput.Royalty < 0 || formInput.Royalty > 100) {
      console.log("Form", formInput);
      valid = false;
      errors.Royalty = "Royalty must be require between 0 and 100.";

    }


    // If validation fails, show errors
    if (!valid) {
      setErrorMessages(errors);
    } else {
      // Proceed with the form submission
      if (func === "draft") {
        DraftPost();
      }
      else if (func === "lazy") {
        LazyPost()
      }
      else  if (func === "mint") {
        CreateMint()
      }
    }
  };


  return (
    <div className="container">
      <div className="box in__upload mt-40 mb-120" style={{ position: "relative" }}>
        <div className="row">
          <div className="col-lg-6">
            <div className="left__part space-y-40 md:mb-20 upload_file">
              {fileUrl && (
                <div id="upload_file_close_button" className="closeButton" onClick={closeButton}>
                  X
                </div>
              )}
              <div className="space-y-20">
                {type !== null ? (
                  type.split('/')[0] === "image" ? (
                    <div>
                      {fileUrl && <img src={fileUrl} alt="Asset" />}
                    </div>
                  ) : (
                    <video src={fileUrl} autoPlay muted loop />
                  )
                ) : null}
              </div>
              {fileUrl ? "" : (
                <div className="space-y-20">
                  <p className="color_text">or choose a file</p>
                  <div id="browse files">
                    <Link to="#" className="btn btn-white">
                      Browse files
                    </Link>
                    <input type="file" onChange={handleFileChange} />
                  </div>
                </div>
              )}
              {fileUrl ? "" : <p className="color_text">Max size: 50MB <br />
                JPG, PNG, GIF, SVG, MP4</p>}
              {assetError && <div className="error-message">{assetError}</div>}
              {fileName && <div style={{ color: "black" }}>{fileName}</div>}
              {errorMessages.asset && <p className="error-message">{errorMessages.asset}</p>}
            </div>
          </div>
          <div className="col-lg-6 " >
            <div className="form-group space-y-10">
              <div className="space-y-20">
                <div className="space-y-10 colletion_ui">
                  <span className="variationInput">Choose collection</span>
                  <div className="d-flex flex-column flex-md-row p-2">
                    <div
                      className={"isSelected_collection d-flex justify-content-between"}
                      onClick={() => setCollectionshow(!collectionshow)}
                    >
                      <div className="d-flex justify-content-start">
                        <img src={selectObj.logo} alt="Dtoc_icon" />
                        <div>
                          <div>
                            <span className="ml-10">{selectObj.name}</span>
                          </div>
                          <div>
                            <p className="ml-10">{selectObj.symbol}</p>
                          </div>
                        </div>
                      </div>
                      <div>
                        {collectionshow ? (
                          <MdKeyboardArrowUp size={32} onClick={() => setCollectionshow(false)} />
                        ) : (
                          <MdOutlineKeyboardArrowDown size={32} onClick={() => setCollectionshow(true)} />
                        )}
                      </div>
                    </div>
                  </div>
                  {collectionshow && (
                    <div className="colletion_ui_data">
                      <div className="d-flex flex-column flex-md-row p-2">
                        <div className={`${isSelected ? "choose_collection" : "isSelected_collection "}  d-flex justify-content-start`} onClick={() => updateStateByIndex(null, true, { logo: "img/icons/raroin_icon.svg", name: "DtoC", symbol: "D2C", contractAddress: contractAddress }, false)}>
                          <img
                            src={`img/logos/dtoc.png`}
                            alt="Dtoc_icon"
                          />
                          <div>
                            <div>
                              <span className=" ml-10">
                                DtoC
                              </span>

                            </div>
                            <div>
                              <p className=" ml-10">
                                D2C
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      {collection.length !== 0 &&
                        collection.map((data, i) => (
                          <div className="d-flex flex-column flex-md-row p-2">
                            <div
                              className={`${data.isActive ? "isSelected_collection" : "choose_collection"
                                } d-flex justify-content-start`}
                              onClick={() => updateStateByIndex(i, true, data, true)}
                            >
                              <img src={data !== null ? data.logo : `img/icons/raroin_icon.svg`} alt="Dtoc_icon" />
                              <div>
                                <div>
                                  <span className="ml-10 d-flex">{data !== null && data.name}</span>
                                </div>
                                <div>
                                  <span className="ml-10">{data !== null && data.symbol}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                    </div>
                  )}
                </div>
                <div className="space-y-10">
                  <span className="nameInput">Title</span>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="e.g. `Dtoc design art`"
                    name="title"
                    onChange={handleChange}
                  />
                  {errorMessages.title && <p className="error-message">{errorMessages.title}</p>}
                </div>
                <div className="space-y-10">
                  <span className="nameInput">Price</span>
                  <input
                    type="number"
                    className="form-control"
                    placeholder="Price"
                    name="price"
                    onChange={handleChangeOfPrice}
                  />
                  {errorMessages.price && <p className="error-message">{errorMessages.price}</p>}
                </div>
                {selectObj.name !== "DtoC" && (
                  <div className="space-y-10 inputs-filds">
                    <span className="nameInput">Royalty</span>
                    <div className="input-container">
                      <input
                        type="number"
                        className="form-control"
                        placeholder="Royalty"
                        name="Royalty"
                        // onChange={handleChange}
                        onChange={(e) => {
                          const value = parseFloat(e.target.value);
                          if (value > 100) {
                            e.target.value = 100; // Set to max value if input exceeds 100
                          }
                          handleChange(e); // Call the change handler
                        }}
                        min="0" // Prevents entering negative numbers
                        max="100" // Prevents entering numbers greater than 100
                        step="0.01" // Optional: Allows decimal numbers
                      />
                      <span className="input-suffix">%</span>
                    </div>
                    {errorMessages.Royalty && <p className="error-message">{errorMessages.Royalty}</p>}
                  </div>
                )}
                <div className="space-y-10">
                  <span className="nameInput">
                    Description
                  </span>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="e. g. `Dtoc design art`"
                    name='desc'
                    onChange={handleChange}
                  />
                </div>
                <div className='space-y-10'>
                  <span className="variationInput">Category</span>
                  <select
                    className="form-select custom-select" style={{ height: "auto" }}
                    aria-label="Default select example" name="category" onChange={handleChange}>
                    <option className="">select a category</option>
                    <option className="" value="Art">
                      Art
                    </option>
                    <option className="" value="Graphics">
                      Graphics
                    </option>
                    <option className="" value="Video">
                      Video
                    </option>
                    <option className="" value="others">
                      others
                    </option>
                  </select>
                  {errorMessages.category && <p className="error-message">{errorMessages.category}</p>}

                </div>
                {show ?
                  <div className='space-y-10'>
                    <div className="d-flex align-items-center justify-content-between">
                      <h4>
                        Attribute
                      </h4>
                      <div>
                        <button
                          className="btn btn-grad space-y-10 mx-10
					btn_create"
                          onClick={() => setShow(false)}
                        >
                          Close
                        </button>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-lg-5">
                        <span className="nameInput">
                          Trait Type
                        </span>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Trait Type"
                          name="trait_type"
                          value={newAttribute.trait_type}
                          onChange={handleInputChange}
                        />
                      </div>
                      <div className="col-lg-5">
                        <span className="nameInput">
                          Value
                        </span>
                        <input
                          type="text"
                          className="form-control"
                          name="value"
                          placeholder="Value"
                          value={newAttribute.value}
                          onChange={handleInputChange}
                        />
                      </div>
                      <div className="col-lg-2" style={{ marginTop: "auto" }}>
                        <button
                          className="btn btn-grad space-y-10
					btn_create"
                          style={{ padding: "5px 10px" }}
                          onClick={handleSubmit}
                        >
                          Add
                        </button>
                      </div>
                    </div>
                  </div>
                  : <button
                    className="btn btn-grad space-y-10 btn_create"
                    onClick={() => setShow(true)}
                  >
                    Add Attribute
                  </button>}
                {attributes.length !== 0 &&
                  <>
                    <p className="my-3">Attributes:</p>
                    <div className="table-responsive">
                      <table
                        id="user-list-table"
                        className="table table-hover"
                        role="grid"
                        data-toggle="data-table"
                      >
                        <thead>
                          <tr className="ligth">
                            <th className="text-center">SNo.</th>
                            <th className="text-center">Trait Type</th>
                            <th className="text-center">Value</th>
                            <th className="text-center">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {attributes.map((attr, i) => {
                            return (
                              <tr key={i}>
                                <td className="text-center">{i + 1}</td>
                                <td className="text-center">{attr.trait_type}</td>
                                <td className="text-center">{attr.value}</td>
                                <td className="text-center" onClick={() => handleDelete(i)} > <MdDelete color="red" /> </td>

                              </tr>
                            )
                          })}
                        </tbody>
                      </table>
                    </div>
                  </>
                }
                <div className="space-y-10 upload_file">
                  <button
                    className="btn btn-grad
					btn_create"
                    onClick={CreateMint}
                  >
                    Upload Properties File
                  </button>
                  <input type="file" accept=".csv" onChange={onJsonChange} />
                </div>
                {csvFileName}
              </div>

              {/* <div className="fixed_row bottom-0 left-0 right-0">
                <div className="container">
                  <div className="row content justify-content-between mb-20_reset">
                    <div className="col-md-auto col-12 mb-20"></div>
                    <div className="col-md-auto col-12 mb-20 space-x-10">
                      <button className="btn btn-grad btn_create"
                        // onClick={handleSubmit}
                        onClick={() => ValidationhandleSubmit("draft")}
                      >
                        Draft Mint
                      </button>
                      {selectObj.name !== "DtoC" && (
                        <button className="btn btn-grad btn_create" onClick={() => ValidationhandleSubmit("lazy")}>
                          Lazy Mint
                        </button>
                      )}
                      <button className="btn btn-grad btn_create" onClick={() => ValidationhandleSubmit('mint')}>
                        Mint NFT
                      </button>
                    </div>
                  </div>
                </div>
              </div> */}
            </div>

          </div>
        </div>
        <div className="col-md-auto col-12 mb-20" style={{ position: "absolute", bottom: "0px", right: "0px" }}>
          <button className="btn btn-grad btn_create"
            // onClick={handleSubmit}
            onClick={() => ValidationhandleSubmit("draft")}
          >
            Draft Mint
          </button>
          {selectObj.name !== "DtoC" && (
            <button className="btn btn-grad btn_create mx-3" onClick={() => ValidationhandleSubmit("lazy")}>
              Lazy Mint
            </button>
          )}
          <button className="btn btn-grad btn_create" onClick={() => ValidationhandleSubmit('mint')}>
            Mint NFT
          </button>
        </div>
      </div>
    </div>
  );
};

export default Upload;